import { Destination } from '@rpldy/shared';
import { AxiosResponse } from 'axios';

import { api } from 'app/utils';

interface DeleteFileResponse {
  success: boolean;
}

const reactAppApiKey = window.CONFIG.gakAPIKey ?? '';

export default class FileUploadService {
  private adapter: api.Adapter;

  constructor(baseUrl: string = window.CONFIG.gakAPIDomain || '') {
    this.adapter = new api.Adapter({
      baseURL: baseUrl,
      headers: {
        timeout: 60 * 10 * 1000,
        'content-type': 'application/json',
        accept: 'application/json'
      }
    });
  }

  uploadFile(): Destination {
    return {
      url: `${window.CONFIG.gakAPIDomain}/file-upload`,
      method: 'PUT',
      filesParamName: 'file',
      headers: {
        'x-api-key': reactAppApiKey
      }
    };
  }

  async deleteFile(uuid: string): Promise<AxiosResponse<DeleteFileResponse>> {
    const headers = {
      'x-uuid': uuid,
      'x-api-key': reactAppApiKey
    };

    return await this.adapter.deleteValue(`${window.CONFIG.gakAPIDomain}/file-upload`, {
      headers
    });
  }
}
